<template>
  <div class="user-data">
    <div class="title-data">
      <pageTitle pageTitle="用户统计">
        <div slot="content">
          1.当日数据更新频率10分钟，建议活动结束后10分钟查看完整数据
          <br />
          2.控制台数据统计为真实数据，不统计虚拟数据
          <br />
          3.当前仅展示观众信息，不展示主持人、嘉宾、助理
        </div>
      </pageTitle>
    </div>
    <title-data :liveDetailInfo="liveDetailInfo"></title-data>
    <div class="active-box">
      <vh-tabs
        v-model="activeName"
        @tab-click="handleClick"
        v-if="liveDetailInfo.webinar_state != 4"
      >
        <vh-tab-pane label="直播" name="1"></vh-tab-pane>
        <vh-tab-pane label="回放" name="2"></vh-tab-pane>
      </vh-tabs>
      <div class="search">
        <vh-select
          round
          filterable
          v-model="type"
          @change="changeType"
          v-if="isSwitch"
          style="width: 160px; vertical-align: top; margin-right: 16px"
        >
          <vh-option
            v-for="(opt, optIndex) in timeData"
            :key="optIndex"
            :label="opt.label"
            :value="opt.value"
          />
        </vh-select>
        <vh-date-picker
          round
          v-model="dateValue"
          value-format="yyyy-MM-dd"
          type="daterange"
          unlink-panels
          @change="searchTime"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          prefix-icon="iconfont-v3 saasicon_date"
          :picker-options="pickerOptions"
          style="width: 250px"
          v-if="type == '1'"
        />
        <vh-select
          round
          filterable
          :clearable="true"
          v-model="switchId"
          v-if="type == '2'"
          :style="{ width: switchId == 0 ? 'auto' : '380px' }"
          @change="searchTableList"
        >
          <vh-option
            v-for="(opt, optIndex) in switchList"
            :key="optIndex"
            :label="opt.label"
            :value="opt.value"
          />
        </vh-select>
        <vh-checkbox
          v-model="checkedValue"
          @change="searchTableList"
          style="margin-left: 16px; margin-right: 16px"
        >
          合并同一用户
        </vh-checkbox>
        <vh-checkbox
          v-if="!switchId && activeName == 1"
          v-model="checkedValue2"
          @change="searchTableList"
          style="margin-left: 16px; margin-right: 16px"
        >
          彩排数据
        </vh-checkbox>
        <vh-input
          round
          class="search-tag"
          placeholder="请输入用户昵称"
          v-clearEmoij
          v-model.trim="title"
          :clearable="true"
          @change="searchTableList"
          @keyup.enter.native="searchTableList"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="searchTableList"></i>
        </vh-input>
        <vh-input
          round
          class="search-tag join_id"
          placeholder="请输入参会ID"
          v-clearEmoij
          v-model.trim="join_id"
          :clearable="true"
          @change="searchTableList"
          @keyup.enter.native="searchTableList"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="searchTableList"></i>
        </vh-input>
        <!-- <vh-input class="inputer" v-model.trim="title" placeholder="请输入用户昵称" style="vertical-align: top;margin-left:20px" @clear="searchTableList" @keyup.enter.native="searchTableList"  clearable><i slot="suffix" class="vh-input__icon vh-icon-search" @click="searchTableList"></i></vh-input> -->
        <div class="export-data" v-if="exportPerssion > 0">
          <vh-button round plain size="medium" @click="openExportDialog">导出数据</vh-button>
        </div>
      </div>
      <div>
        <table-list
          ref="tableList"
          :manageTableData="tableList"
          :tabelColumnLabel="tabelColumn"
          :isHandle="false"
          :isCheckout="false"
          :totalNum="totalNum"
          :needPagination="tableList.length > 0"
          @changeTableCheckbox="changeTableCheckbox"
          @getTableList="getTableList"
        ></table-list>
        <noData
          v-show="tableList.length === 0"
          :nullType="'nullData'"
          :text="'暂无数据'"
          :height="100"
        ></noData>
      </div>
    </div>
    <vh-dialog
      title="设置表头"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="734px"
    >
      <div class="dialog-body">
        <div class="check-box-panel">
          <vh-checkbox-group v-model="dialogCheckList" class="checkbox-group">
            <vh-checkbox
              v-for="(val, key) in exportColumn"
              :key="key"
              :label="key"
              class="checkbox-item"
            >
              {{ val }}
            </vh-checkbox>
          </vh-checkbox-group>
        </div>
        <div class="drag-panel">
          <span class="label">当前选定的字段</span>
          <draggable
            :class="['draggable-check-list-group', dragging ? 'dragging' : '']"
            tag="ul"
            :list="dialogCheckList"
            handle=".move"
            @start="dragging = true"
            @end="dragging = false"
            v-bind="{
              animation: 200,
              group: 'description',
              disabled: false,
              ghostClass: 'ghost'
            }"
          >
            <template v-for="item in dialogCheckList">
              <li
                v-if="item !== 'name' && exportColumn[item]"
                class="draggable-check-item move"
                :key="item"
              >
                <img :src="require('@/common/images/icon/icon_dot.png')" class="dot" />
                <span class="column ellipse">{{ exportColumn[item] }}</span>
                <i class="vh-icon-close del-btn" @click="cancelCheck(item)"></i>
              </li>
            </template>
          </draggable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <vh-button size="medium" type="info" plain round @click="dialogVisible = false">
          取消
        </vh-button>
        <vh-button size="medium" type="primary" round @click="exportCenterData">导出</vh-button>
      </span>
    </vh-dialog>
  </div>
</template>
<script>
  import titleData from './components/title';
  import noData from '@/views/PlatformModule/Error/nullPage';
  import PageTitle from '@/components/PageTitle';
  import { sessionOrLocal } from '@/utils/utils';
  import { throttle } from 'lodash';
  import draggable from 'vuedraggable';
  export default {
    data() {
      let _this = this;
      return {
        dialogVisible: false,
        dialogCheckList: [],
        exportColumn: {
          nick_name: '昵称',
          join_id: '参会ID',
          join_time: '进入时间',
          watch_duration: '观看时长',
          watch_type: '观看终端',
          watch_provice: '地理位置',
          ip: 'IP',
          refer: '渠道来源',
          white_name: '白名单昵称',
          phone: '手机号',
          email: '邮箱',
          white_job_number: '工号',
          white_other: '其他',
          fs_code: '邀请码',
          fs_time: '使用邀请码时间',
          third_account_id: '三方用户id',
          visit_id: '游客id',
          watch_times: '观看次数'
        },
        dragging: false,
        active: 2,
        totalNum: 0,
        isHandle: false,
        params: {}, //导出的时候用来记录参数
        activeName: '1',
        type: '1',
        switchId: 0,
        dateValue: '',
        timeType: 0,
        checkedValue: false,
        checkedValue2: true, //是否是彩排数据
        title: '',
        join_id: '',
        userId: JSON.parse(sessionOrLocal.get('userId')),
        liveDetailInfo: {},
        switchList: [],
        tableList: [],
        isSwitch: true,
        tabelColumn: [
          {
            label: '用户信息',
            key: 'avatar_nickname',
            width: '150px'
          },
          {
            label: '手机号',
            key: 'phone',
            customTooltip: true
          },
          {
            label: '邮箱',
            key: 'email',
            customTooltip: true
          },
          {
            label: '参会ID',
            key: 'join_id',
            customTooltip: true
          },
          {
            label: '进入时间',
            key: 'join_time',
            customTooltip: true
          },
          {
            label: '观看时长（分）',
            key: 'watch_duration',
            width: '200px'
          },
          {
            label: '观看终端',
            key: 'watch_type'
          },
          {
            label: '地理位置',
            key: 'watch_provice'
          },
          {
            label: 'IP地址',
            key: 'ip'
          }
        ],

        timeData: [
          {
            label: '按时间筛选',
            value: '1'
          },
          {
            label: '按场次筛选',
            value: '2'
          }
        ],
        pickerOptions: {
          shortcuts: [
            {
              text: '今日',
              onClick(picker) {
                let childrenArray = Array.from(picker.$el.firstChild.firstChild.children);
                childrenArray.forEach(item => {
                  item.style.color = '#666';
                });
                picker.$el.firstChild.firstChild.children[0].style.color = '#FB3A32';
                const end = new Date();
                const start = new Date();
                end.setTime(end.getTime());
                start.setTime(start.getTime());
                picker.$emit('pick', [start, end]);
                _this.timeType = 0;
              }
            },
            {
              text: '近7日',
              onClick(picker) {
                let childrenArray = Array.from(picker.$el.firstChild.firstChild.children);
                childrenArray.forEach(item => {
                  item.style.color = '#666';
                });
                picker.$el.firstChild.firstChild.children[1].style.color = '#FB3A32';
                const end = new Date();
                const start = new Date();
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
                _this.timeType = 1;
              }
            },
            {
              text: '近30日',
              onClick(picker) {
                let childrenArray = Array.from(picker.$el.firstChild.firstChild.children);
                childrenArray.forEach(item => {
                  item.style.color = '#666';
                });
                picker.$el.firstChild.firstChild.children[2].style.color = '#FB3A32';
                const end = new Date();
                const start = new Date();
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
                _this.timeType = 2;
              }
            }
          ],
          // disabledDate是一个函数,参数是当前选中的日期值,这个函数需要返回一个Boolean值,
          disabledDate: time => {
            return this.dealDisabledData(time);
          }
        }
      };
    },
    components: {
      titleData,
      noData,
      PageTitle,
      draggable
    },
    computed: {
      exportPerssion() {
        return this.$store.state.permissionValue?.data_export;
      }
    },
    created() {
      this.initPage();
      this.getLiveDetail();
    },
    watch: {
      active(value) {
        this.active = value;
      }
    },
    mounted() {},
    methods: {
      openExportDialog() {
        this.dialogVisible = true;
        this.$fetch('getTableColumns', { config_type: 1 }).then(res => {
          if (res.code == 200 && res.data) {
            this.originTableColumns = res.data;
            const data = JSON.parse(res.data);
            const arr = Object.keys(data);
            this.dialogCheckList = arr;
          }
        });
      },
      cancelCheck(item) {
        const idx = this.dialogCheckList.findIndex(key => {
          return key === item;
        });
        if (idx > -1) {
          this.dialogCheckList.splice(idx, 1);
        }
      },
      dealDisabledData(time) {
        return time.getTime() > Date.now(); //设置选择今天以及今天以前的日期
        // return time.getTime() > Date.now() - 8.64e7 //设置选择今天之前的日期（不能选择当天）
      },
      initPage() {
        // 初始化设置日期为今天
        const end = new Date();
        const start = new Date();
        end.setTime(end.getTime());
        start.setTime(start.getTime());
        this.dateValue = [dayjs(start).format('YYYY-MM-DD'), dayjs(end).format('YYYY-MM-DD')];
      },
      searchTime() {
        if (this.type == 1) {
          let timeArr = [100475, 100476, 100477];
          let vitimeArr = [100483, 100484, 100485];
          this.$vhall_paas_port({
            k: this.activeName == 1 ? timeArr[this.timeType] : vitimeArr[this.timeType],
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        this.getTableList('search');
      },
      searchTableList() {
        if (this.checkedValue) {
          this.$vhall_paas_port({
            k: this.activeName == 1 ? 100480 : 100486,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        if (this.title) {
          this.$vhall_paas_port({
            k: this.activeName == 1 ? 100482 : 100488,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        this.getTableList('search');
      },
      //获取直播详情
      getLiveDetail() {
        // webinar/info调整-正常的信息展示使用 0
        this.$fetch('getWebinarInfo', { webinar_id: this.$route.params.str, is_rehearsal: 0 })
          .then(res => {
            this.liveDetailInfo = res.data;
            if (this.liveDetailInfo.webinar_state != 4) {
              this.getLiveSwitchInfo();
            } else {
              this.isSwitch = false;
              this.activeName = '2';
            }
            this.getTableList();
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `获取信息失败`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            console.log(res);
          });
      },
      // 获取直播场次
      getLiveSwitchInfo() {
        this.switchList = [
          {
            label: `全部`,
            value: 0
          }
        ];
        this.$fetch('getWebinarSwitchList', { webinar_id: this.$route.params.str }).then(res => {
          res.data.switch_list.map((item, index) => {
            this.switchList.push({
              label: `第${res.data.switch_list.length - index}场 ${
                item.type == 2 ? '(彩排)' : ''
              }（${item.start_time} ~ ${item.end_time}）`,
              value: item.id
            });
          });
        });
      },
      getTableList(params) {
        let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        // let formParams = this.$refs.searchArea.searchParams; //获取搜索参数
        const switch_id = this.checkedValue2 ? 0 : -1;
        let paramsObj = {
          webinar_id: this.$route.params.str,
          switch_id: this.switchId || switch_id,
          service_names: this.liveDetailInfo.webinar_state == 4 ? '2' : this.activeName,
          start_time: this.dateValue ? this.dateValue[0] : '',
          end_time: this.dateValue ? this.dateValue[1] : '',
          merge_type: this.checkedValue ? 1 : 2,
          nick_name: this.title,
          join_id: this.join_id
        };
        if (params === 'search') {
          pageInfo.pageNum = 1;
          pageInfo.pos = 0;
        }
        let obj = Object.assign({}, pageInfo, paramsObj);
        this.params = paramsObj;
        this.getBaseUserInfo(obj);
      },
      getBaseUserInfo(params) {
        this.$fetch('getUserBaseinfo', this.$params(params)).then(res => {
          this.tableList = res.data.list;
          this.tableList.map(item => {
            item.watch_provice = `${item.watch_provice}-${item.watch_city}`;
          });
          this.totalNum = res.data.total;
        });
      },
      // 导出
      exportCenterData: throttle(
        async function () {
          const tabelColumns = {};
          this.dialogCheckList.forEach(el => {
            tabelColumns[el] = this.exportColumn[el];
          });
          const config = JSON.stringify(tabelColumns);
          console.error(config, this.originTableColumns);
          if (config != this.originTableColumns) {
            await this.$fetch('setTableColumns', { config_type: 1, config });
          }
          this.$fetch('exportUserinfo', this.params)
            .then(res => {
              this.$vhall_paas_port({
                k: this.activeName == 1 ? 100481 : 100487,
                data: {
                  business_uid: this.userId,
                  user_id: '',
                  webinar_id: this.$route.params.str,
                  refer: '',
                  s: '',
                  report_extra: {},
                  ref_url: '',
                  req_url: ''
                }
              });
              this.dialogVisible = false;
              this.$vhMessage({
                message: `用户统计数据导出申请成功，${
                  this.$store.state.permissionValue.custom_download_toast || '请去下载中心下载'
                }`,
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              this.$EventBus.$emit('saas_vs_download_change');
            })
            .catch(res => {
              this.$vhMessage({
                message: res.msg || `用户统计数据导出失败`,
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        },
        2000,
        {
          trailing: false
        }
      ),
      changeTableCheckbox(val) {
        console.log(val);
      },
      changeType() {
        this.switchId = '';
        if (this.type == 1) {
          this.initPage();
        } else {
          this.dateValue = '';
        }
        this.$vhall_paas_port({
          k: this.type == 1 ? 100478 : 100479,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: this.$route.params.str,
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.getTableList('search');
      },
      handleClick(tab) {
        this.activeName = tab.name;
        // tab切换时搜索的值和分页的值都重置
        this.isSwitch = tab.name == '2' ? false : true;
        let queryDocument = document.querySelectorAll('.vh-picker-panel__shortcut');
        if (queryDocument.length > 0) {
          queryDocument[0].style.color = '#fb3a32';
          queryDocument[1].style.color = '#666';
          queryDocument[2].style.color = '#666';
        }
        this.initPage();
        this.type = '1';
        this.title = '';
        this.checkedValue = false;
        this.checkedValue2 = true;
        this.switchId = 0;
        this.getTableList('search');
      }
    }
  };
</script>
<style lang="less">
  .vh-picker-panel__shortcut:nth-of-type(1) {
    color: #fb3a32;
  }
  .vh-picker-panel__shortcut:nth-of-type(2) {
    color: #666;
  }
</style>
<style lang="less" scoped>
  .user-data {
    padding: 0;
    .container-box {
      margin-bottom: 24px;
    }
    .search {
      padding: 0 124px 0 24px;
      margin: 24px 0;
      position: relative;
      .export-data {
        position: absolute;
        right: 24px;
        top: 0;
      }

      .search-tag {
        margin-right: 20px;
        margin-bottom: 10px;
        width: 160px !important;
      }
    }
    .data-list {
      padding: 0 24px;
    }

    .title-data {
      margin: 20px 0;
      text-align: left;
      line-height: 30px;
      i {
        padding: 4px;
        font-size: 14px;
      }
      span {
        font-size: 22px;
        font-weight: 600;
        color: #1a1a1a;
      }
    }
    .active-box {
      padding: 24px 0;
      border-radius: 4px;
      background: #fff;
      padding-top: 1px;
    }
  }
  .dialog-body {
    overflow: hidden;
  }
  .check-box-panel {
    width: 500px;
    float: left;
    .checkbox-group {
      display: flex;
      flex-wrap: wrap;
      .checkbox-item {
        width: 50%;
        margin-right: 0;
        margin-bottom: 10px;
        .el-checkbox {
          width: 100%;
        }
      }
    }
  }

  .drag-panel {
    width: 170px;
    height: 300px;
    float: right;
    border-left: 1px solid rgba(#000, 0.06);
    padding-left: 24px;
    overflow: hidden;

    .label {
      display: inline-block;
      line-height: 22px;
      font-size: 14px;
      color: #737373;
      margin-bottom: 8px;
    }
  }

  .draggable-check-list-group {
    height: 265px;
    padding-right: 8px;
    overflow: auto;

    &:not(.dragging) {
      .draggable-check-item:hover {
        background-color: #f5f5f5;
      }
    }
  }

  .draggable-check-item {
    box-sizing: border-box;
    height: 22px;
    line-height: 22px;
    width: 100%;
    padding: 0 4px 0 0;
    margin-bottom: 8px;
    cursor: move;
    position: relative;

    &.ghost {
      background-color: #e6e6e6;

      &:after {
        content: ' ';
        width: 100%;
        height: 1.2px;
        position: absolute;
        background-color: #fedede;
        left: 0;
        bottom: -4px;
      }
    }

    .dot {
      display: inline-block;
      position: absolute;
      top: 3px;
      left: 0;
      height: 16px;
      width: 16px;
    }

    .column {
      display: inline-block;
      width: 100px;
      margin-left: 20px;
      line-height: 22px;
      font-size: 14px;
    }

    .del-btn {
      position: absolute;
      top: 3px;
      right: 3px;
      width: 16px;
      height: 16px;
      padding: 2px;
      border-radius: 2px;
      cursor: pointer;
      font-size: 12px;
      transform: scale(0.9);
    }

    ::after {
      clear: both;
    }
  }
</style>
